import { NavigateFunction } from 'react-router-dom';

// Lets Redux actions/services navigate imperatively from outside the React tree.
// AppRoutes (in routes.tsx) captures the real navigate() from useNavigate() here
// on mount; every call site in this codebase only ever passes a plain path string.
export const navigationRef: { current: NavigateFunction | null } = { current: null };

export const navigate = (to: string) => {
  navigationRef.current?.(to);
};
